// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Machine Management Component Styles */

/* Base Layout */
.MachineContainer {
  min-height: 100vh;
  /* background: linear-gradient(
    135deg,
    #f0fdf4 0%,
    #ffffff 50%,
    rgba(240, 253, 244, 0.3) 100%
  ); */
}

/* Header Section */

.MachineStatsCard {
  background: #15803d;
  color: #ffffff;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.MachineStatsContent {
  display: flex;
  align-items: center;
  gap: 8px;
}

.MachineStatsText {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
}

.MachineStatsNumber {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

/* Main Content */
.MachineMainContent {
  max-width: 1280px;
  margin: 0 auto;
  /* padding: 32px 16px; */
}

.machine-header {
  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */
  background: linear-gradient(135deg, #20948b 0%, #66a5ad 100%);
  padding: 11px 20px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.machine-header::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  animation: pulse 15s infinite linear;
}

@keyframes pulse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.machine-header-content {
  position: relative;
  z-index: 2;
}

.machine-title {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.machine-subtitle {
  font-size: 18px;
  font-weight: 400;
  opacity: 0.9;
  text-align: center;
}
.MachineStatus {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.MachineStatus.Active { background: #d4edda; color: #155724; }
.MachineStatus.Expiring { background: #fff3cd; color: #856404; }
.MachineStatus.Expired { background: #f8d7da; color: #721c24; }

.MachineBadge {
  background: #e0e7ff;
  color: #4338ca;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.MachineLink {
  color: #4f46e5;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
}
.MachineLink:hover {
  text-decoration: underline;
}

/* Action Bar */
.MachineActionBar {
  /* background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border: 1px solid #dcfce7;
  padding: 24px; */
  margin-bottom: 32px;
}

.MachineActionBarContent {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.MachineSearchContainer {
  position: relative;
  flex: 1 1;
  max-width: 448px;
}

.MachineSearchIcon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  width: 20px;
  height: 20px;
}

.MachineSearchInput {
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-family: "Source Sans Pro", sans-serif;
  transition: all 0.2s ease;
}

.MachineSearchInput:focus {
  outline: none;
  border-color: transparent;
  box-shadow: 0 0 0 2px #15803d;
}

.MachineActionButtons {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.MachineButton {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: none;
  border-radius: 12px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.MachineButtonSecondary {
  color: #6b7280;
  background: #f9fafb;
}

.MachineButtonSecondary:hover {
  background: #f3f4f6;
}

.MachineButtonPrimary {
  color: #ffffff;
  background: #6b7280;
  font-weight: 600;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.MachineButtonPrimary:hover {
  /* background: #166534; */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

/* Loading State */
.MachineLoading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
}

.MachineLoadingContent {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MachineSpinner {
  width: 32px;
  height: 32px;
  border: 4px solid #dcfce7;
  border-top: 4px solid #15803d;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.MachineLoadingText {
  color: #6b7280;
  /* font-family: "Source Sans Pro", sans-serif; */
}

/* Desktop Table */
.MachineTableContainer {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border: 1px solid #dcfce7;
  overflow: hidden;
}

.MachineTable {
  width: 100%;
  border-collapse: collapse;
}

.MachineTableHeader {
  background: #f3f4f6;
  border-bottom: 1px solid #dcfce7;
}

.MachineTableHeaderCell {
  padding: 16px 24px;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  font-family: sans-serif;
}

.MachineTableBody {
  background: #ffffff;
}

.MachineTableRow {
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.15s ease;
}

.MachineTableRow:hover {
  background: #f8f8f8;
}

.MachineTableCell {
  padding: 16px 16px;
}

.MachineCellContent {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MachineCellIcon {
  padding: 8px;
  /* background: #dcfce7; */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  /* background: linear-gradient(135deg, #8AAAE5 50%, #CADCFC 100%); */
  background: #6b7280;
  border-radius: 8px;
}

.MachineCellIcon svg {
  width: 20px;
  height: 20px;
  color: #ffffff;
}

.MachineCellTitle {
  font-weight: 600;
  color: #111827;
  /* font-family: "Source Sans Pro", sans-serif; */
  margin: 0;
}

.MachineCellSubtitle {
  font-size: 0.875rem;
  color: #6b7280;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
}

.MachineLocationContent {
  /* display: flex; */
  display: inline-flex;
  align-items: center;
  /* gap: 8px; */
  background-color: #6b7280;
  color: #f8f8f8;
  border-radius: 1rem;
  padding: 0.25rem 0.6rem;
}

.MachineLocationIcon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  /* color: #9ca3af; */
}

.MachineLocationText {
  font-size: 0.875rem;
  line-height: 1;
  /* color: #6b7280; */
  /* font-family: "Source Sans Pro", sans-serif; */
}

.MachineActionCell {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 8px;
}

.MachineActionButton {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.MachineActionButtonView {
  stroke-width: 2;
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border: 1px solid #e5e7eb;
}

.MachineActionButtonView:hover {
  /* background: #bfdbfe; */
  /* color: #10b981; */
  /* transform: scale(1.1); */
  border-color: #10b981;
}

.MachineActionButtonEdit {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  stroke-width: 2;
  border: 1px solid #e5e7eb;
}

.MachineActionButtonEdit:hover {
  /* background-color: #dbeafe; */
  border-color: #3b82f6;
  /* transform: scale(1.1); */
}

.MachineActionButtonDelete {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  stroke-width: 2;
  border: 1px solid #e5e7eb;
}

.MachineActionButtonDelete:hover {
  /* background-color: #fee2e2; */
  /* transform: scale(1.1); */
  border-color: #ef4444;
}

/* Mobile Cards */
.MachineMobileContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.MachineMobileCard {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border: 1px solid #dcfce7;
  padding: 24px;
}

.MachineMobileCardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.MachineMobileCardTitle {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MachineMobileCardActions {
  display: flex;
  gap: 8px;
}

.MachineMobileCardGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  font-size: 0.875rem;
}

.MachineMobileCardField {
  display: flex;
  flex-direction: column;
}

.MachineMobileCardLabel {
  color: #6b7280;
  /* font-family: "Source Sans Pro", sans-serif; */
  margin: 0 0 4px 0;
}

.MachineMobileCardValue {
  font-weight: 500;
  color: #111827;
  /* font-family: "Source Sans Pro", sans-serif; */
  margin: 0;
}

.MachineEmptyState {
  text-align: center;
  padding: 48px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.MachineEmptyIcon {
  padding: 16px;
  background: #f3f4f6;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
}

.MachineEmptyIcon svg {
  width: 32px;
  height: 32px;
  color: #9ca3af;
  margin: auto;
  margin-top: 8px;
}

.MachineEmptyTitle {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  font-family: "Playfair Display", serif;
  margin: 0 0 8px 0;
}

.MachineEmptyDescription {
  color: #6b7280;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0 0 24px 0;
}

/* Modal Overlay */
.MachineModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  padding: 16px;
}

.MachineModal {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 896px;
  max-height: 90vh;
  overflow-y: auto;
}

.MachineModalHeader {
  position: sticky;
  top: 0;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 24px;
  border-radius: 16px 16px 0 0;
}

.MachineModalHeaderContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.MachineModalTitle {
  font-size: 1.5rem;
  /* font-family: "Playfair Display", serif; */
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.MachineModalClose {
  padding: 8px;
  color: #9ca3af;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.MachineModalClose:hover {
  color: #6b7280;
  background: #f3f4f6;
}

.MachineModalContent {
  padding: 24px;
}

/* Form Styles */
.MachineForm {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.MachineFormGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.MachineFormField {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MachineFormLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  font-family: "Source Sans Pro", sans-serif;
}

.MachineFormLabel svg {
  width: 16px;
  height: 16px;
  color: #0d5787;
}

.MachineFormInput {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-family: "Source Sans Pro", sans-serif;
  transition: all 0.2s ease;
}

.MachineFormInput:focus {
  outline: none;
  border-color: transparent;
  box-shadow: 0 0 0 2px #e5e9e7;
}

.MachineFormTextarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-family: "Source Sans Pro", sans-serif;
  resize: none;
  transition: all 0.2s ease;
}

.MachineFormTextarea:focus {
  outline: none;
  border-color: transparent;
  box-shadow: 0 0 0 2px #e5e9e7;
}

.MachineFormActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.MachineFormCancel {
  padding: 12px 24px;
  color: #6b7280;
  background: #f3f4f6;
  border: none;
  border-radius: 12px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.MachineFormCancel:hover {
  background: #e5e7eb;
}

.MachineFormSubmit {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);

  color: #ffffff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.MachineFormSubmit:hover {
  /* background: #166534; */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.MachineFormSubmit:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* View Modal Styles */
.MachineViewHeader {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MachineViewIcon {
  padding: 8px;
  background: #dcfce7;
  border-radius: 8px;
}

.MachineViewIcon svg {
  width: 24px;
  height: 24px;
  color: #0d5787;
}

.MachineViewGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.MachineViewSection {
  padding: 16px;
  border-radius: 12px;
}

.MachineViewSectionGreen {
  background: #f3f4f6;
}

.MachineViewSectionBlue {
  background: #f3f4f6;
}

.MachineViewSectionAmber {
  background: #f3f4f6;
}

.MachineViewSectionPurple {
  background: #f3f4f6;
}

.MachineViewSectionGray {
  background: #f3f4f6;
}

.MachineViewSectionHeader {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.MachineViewSectionTitle {
  font-weight: 600;
  color: #111827;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
}

.MachineViewSectionContent {
  /* display: flex; */
  /* flex-direction: column; */
  gap: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.MachineViewField {
  display: flex;
  flex-direction: column;
}

.MachineViewFieldLabel {
  font-size: 0.875rem;
  color: #6b7280;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0 0 2px 0;
}

.MachineViewFieldValue {
  font-weight: 500;
  color: #111827;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
}

.MachineViewDescription {
  color: #374151;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 1.6;
  margin: 0;
}
@media (max-width: 425px) {
  .MachineActionButton {
    padding: 0px;
    /* border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.15s ease; */
  }
  .MachineActionButtonView {
    color: #2563eb;
    background: none;
  }
  .MachineActionButtonEdit {
    color: #d97706;
    background: none;
  }
  .MachineActionButtonDelete {
    color: #dc2626;
    background: none;
  }
}
/* Responsive Design */
@media (min-width: 640px) {
  .MachineActionBarContent {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

@media (min-width: 768px) {
  .MachineFormGrid {
    grid-template-columns: repeat(3, 1fr);
  }

  .MachineViewGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .MachineHeaderContent {
    /* flex-direction: row; */
    align-items: center;
    justify-content: space-between;
  }

  .MachineTitle {
    font-size: 2.25rem;
  }

  .MachineMobileContainer {
    display: none;
  }

  .MachineTableContainer {
    display: block;
  }
}

@media (max-width: 1023px) {
  .MachineTableContainer {
    display: none;
  }

  .MachineMobileContainer {
    display: flex;
  }
}

/* Full width for description field */
.MachineFormFieldFull {
  grid-column: 1 / -1;
}
.radio-group label {
  font-size: 15px;
  color: #374151;
}

.radio-group input[type="radio"] {
  width: 18px;
  height: 18px;
  accent-color: #3b82f6; /* or your primary color */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Machine/machine.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,gBAAgB;AAChB;EACE,iBAAiB;EACjB;;;;;MAKI;AACN;;AAEA,mBAAmB;;AAEnB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mEAAmE;EACnE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;;;;kBAIgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;EACnE,oEAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;;EAE7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,QAAQ;EACR,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;AACX;AACA;EACE;IACE,YAAY;IACZ;;;8CAG0C;EAC5C;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB,EAAE,0BAA0B;AACnD","sourcesContent":["/* Machine Management Component Styles */\n\n/* Base Layout */\n.MachineContainer {\n  min-height: 100vh;\n  /* background: linear-gradient(\n    135deg,\n    #f0fdf4 0%,\n    #ffffff 50%,\n    rgba(240, 253, 244, 0.3) 100%\n  ); */\n}\n\n/* Header Section */\n\n.MachineStatsCard {\n  background: #15803d;\n  color: #ffffff;\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.MachineStatsContent {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.MachineStatsText {\n  font-size: 0.875rem;\n  opacity: 0.9;\n  margin: 0;\n}\n\n.MachineStatsNumber {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n/* Main Content */\n.MachineMainContent {\n  max-width: 1280px;\n  margin: 0 auto;\n  /* padding: 32px 16px; */\n}\n\n.machine-header {\n  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */\n  background: linear-gradient(135deg, #20948b 0%, #66a5ad 100%);\n  padding: 11px 20px;\n  color: white;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin-bottom: 40px;\n}\n\n.machine-header::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.15) 0%,\n    transparent 60%\n  );\n  animation: pulse 15s infinite linear;\n}\n\n@keyframes pulse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.machine-header-content {\n  position: relative;\n  z-index: 2;\n}\n\n.machine-title {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.machine-subtitle {\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.9;\n  text-align: center;\n}\n.MachineStatus {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.MachineStatus.Active { background: #d4edda; color: #155724; }\n.MachineStatus.Expiring { background: #fff3cd; color: #856404; }\n.MachineStatus.Expired { background: #f8d7da; color: #721c24; }\n\n.MachineBadge {\n  background: #e0e7ff;\n  color: #4338ca;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n}\n\n.MachineLink {\n  color: #4f46e5;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.MachineLink:hover {\n  text-decoration: underline;\n}\n\n/* Action Bar */\n.MachineActionBar {\n  /* background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #dcfce7;\n  padding: 24px; */\n  margin-bottom: 32px;\n}\n\n.MachineActionBarContent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.MachineSearchContainer {\n  position: relative;\n  flex: 1;\n  max-width: 448px;\n}\n\n.MachineSearchIcon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  width: 20px;\n  height: 20px;\n}\n\n.MachineSearchInput {\n  width: 100%;\n  padding: 12px 16px 12px 48px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  transition: all 0.2s ease;\n}\n\n.MachineSearchInput:focus {\n  outline: none;\n  border-color: transparent;\n  box-shadow: 0 0 0 2px #15803d;\n}\n\n.MachineActionButtons {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.MachineButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.MachineButtonSecondary {\n  color: #6b7280;\n  background: #f9fafb;\n}\n\n.MachineButtonSecondary:hover {\n  background: #f3f4f6;\n}\n\n.MachineButtonPrimary {\n  color: #ffffff;\n  background: #6b7280;\n  font-weight: 600;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.MachineButtonPrimary:hover {\n  /* background: #166534; */\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n/* Loading State */\n.MachineLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 0;\n}\n\n.MachineLoadingContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MachineSpinner {\n  width: 32px;\n  height: 32px;\n  border: 4px solid #dcfce7;\n  border-top: 4px solid #15803d;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.MachineLoadingText {\n  color: #6b7280;\n  /* font-family: \"Source Sans Pro\", sans-serif; */\n}\n\n/* Desktop Table */\n.MachineTableContainer {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #dcfce7;\n  overflow: hidden;\n}\n\n.MachineTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.MachineTableHeader {\n  background: #f3f4f6;\n  border-bottom: 1px solid #dcfce7;\n}\n\n.MachineTableHeaderCell {\n  padding: 16px 24px;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #111827;\n  font-family: sans-serif;\n}\n\n.MachineTableBody {\n  background: #ffffff;\n}\n\n.MachineTableRow {\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.15s ease;\n}\n\n.MachineTableRow:hover {\n  background: #f8f8f8;\n}\n\n.MachineTableCell {\n  padding: 16px 16px;\n}\n\n.MachineCellContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MachineCellIcon {\n  padding: 8px;\n  /* background: #dcfce7; */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  /* background: linear-gradient(135deg, #8AAAE5 50%, #CADCFC 100%); */\n  background: #6b7280;\n  border-radius: 8px;\n}\n\n.MachineCellIcon svg {\n  width: 20px;\n  height: 20px;\n  color: #ffffff;\n}\n\n.MachineCellTitle {\n  font-weight: 600;\n  color: #111827;\n  /* font-family: \"Source Sans Pro\", sans-serif; */\n  margin: 0;\n}\n\n.MachineCellSubtitle {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin: 0;\n}\n\n.MachineLocationContent {\n  /* display: flex; */\n  display: inline-flex;\n  align-items: center;\n  /* gap: 8px; */\n  background-color: #6b7280;\n  color: #f8f8f8;\n  border-radius: 1rem;\n  padding: 0.25rem 0.6rem;\n}\n\n.MachineLocationIcon {\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n  /* color: #9ca3af; */\n}\n\n.MachineLocationText {\n  font-size: 0.875rem;\n  line-height: 1;\n  /* color: #6b7280; */\n  /* font-family: \"Source Sans Pro\", sans-serif; */\n}\n\n.MachineActionCell {\n  display: flex;\n  align-items: center;\n  /* justify-content: center; */\n  gap: 8px;\n}\n\n.MachineActionButton {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.MachineActionButtonView {\n  stroke-width: 2;\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n  border: 1px solid #e5e7eb;\n}\n\n.MachineActionButtonView:hover {\n  /* background: #bfdbfe; */\n  /* color: #10b981; */\n  /* transform: scale(1.1); */\n  border-color: #10b981;\n}\n\n.MachineActionButtonEdit {\n  color: #3b82f6;\n  background: rgba(59, 130, 246, 0.1);\n  stroke-width: 2;\n  border: 1px solid #e5e7eb;\n}\n\n.MachineActionButtonEdit:hover {\n  /* background-color: #dbeafe; */\n  border-color: #3b82f6;\n  /* transform: scale(1.1); */\n}\n\n.MachineActionButtonDelete {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n  stroke-width: 2;\n  border: 1px solid #e5e7eb;\n}\n\n.MachineActionButtonDelete:hover {\n  /* background-color: #fee2e2; */\n  /* transform: scale(1.1); */\n  border-color: #ef4444;\n}\n\n/* Mobile Cards */\n.MachineMobileContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.MachineMobileCard {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #dcfce7;\n  padding: 24px;\n}\n\n.MachineMobileCardHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.MachineMobileCardTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MachineMobileCardActions {\n  display: flex;\n  gap: 8px;\n}\n\n.MachineMobileCardGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  font-size: 0.875rem;\n}\n\n.MachineMobileCardField {\n  display: flex;\n  flex-direction: column;\n}\n\n.MachineMobileCardLabel {\n  color: #6b7280;\n  /* font-family: \"Source Sans Pro\", sans-serif; */\n  margin: 0 0 4px 0;\n}\n\n.MachineMobileCardValue {\n  font-weight: 500;\n  color: #111827;\n  /* font-family: \"Source Sans Pro\", sans-serif; */\n  margin: 0;\n}\n\n.MachineEmptyState {\n  text-align: center;\n  padding: 48px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.MachineEmptyIcon {\n  padding: 16px;\n  background: #f3f4f6;\n  border-radius: 50%;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 16px;\n}\n\n.MachineEmptyIcon svg {\n  width: 32px;\n  height: 32px;\n  color: #9ca3af;\n  margin: auto;\n  margin-top: 8px;\n}\n\n.MachineEmptyTitle {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n  font-family: \"Playfair Display\", serif;\n  margin: 0 0 8px 0;\n}\n\n.MachineEmptyDescription {\n  color: #6b7280;\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin: 0 0 24px 0;\n}\n\n/* Modal Overlay */\n.MachineModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n  padding: 16px;\n}\n\n.MachineModal {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 896px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.MachineModalHeader {\n  position: sticky;\n  top: 0;\n  background: #ffffff;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 16px 24px;\n  border-radius: 16px 16px 0 0;\n}\n\n.MachineModalHeaderContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.MachineModalTitle {\n  font-size: 1.5rem;\n  /* font-family: \"Playfair Display\", serif; */\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n\n.MachineModalClose {\n  padding: 8px;\n  color: #9ca3af;\n  background: none;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.MachineModalClose:hover {\n  color: #6b7280;\n  background: #f3f4f6;\n}\n\n.MachineModalContent {\n  padding: 24px;\n}\n\n/* Form Styles */\n.MachineForm {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n}\n\n.MachineFormGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.MachineFormField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MachineFormLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  font-family: \"Source Sans Pro\", sans-serif;\n}\n\n.MachineFormLabel svg {\n  width: 16px;\n  height: 16px;\n  color: #0d5787;\n}\n\n.MachineFormInput {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  transition: all 0.2s ease;\n}\n\n.MachineFormInput:focus {\n  outline: none;\n  border-color: transparent;\n  box-shadow: 0 0 0 2px #e5e9e7;\n}\n\n.MachineFormTextarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  resize: none;\n  transition: all 0.2s ease;\n}\n\n.MachineFormTextarea:focus {\n  outline: none;\n  border-color: transparent;\n  box-shadow: 0 0 0 2px #e5e9e7;\n}\n\n.MachineFormActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.MachineFormCancel {\n  padding: 12px 24px;\n  color: #6b7280;\n  background: #f3f4f6;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.MachineFormCancel:hover {\n  background: #e5e7eb;\n}\n\n.MachineFormSubmit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.MachineFormSubmit:hover {\n  /* background: #166534; */\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.MachineFormSubmit:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* View Modal Styles */\n.MachineViewHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MachineViewIcon {\n  padding: 8px;\n  background: #dcfce7;\n  border-radius: 8px;\n}\n\n.MachineViewIcon svg {\n  width: 24px;\n  height: 24px;\n  color: #0d5787;\n}\n\n.MachineViewGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.MachineViewSection {\n  padding: 16px;\n  border-radius: 12px;\n}\n\n.MachineViewSectionGreen {\n  background: #f3f4f6;\n}\n\n.MachineViewSectionBlue {\n  background: #f3f4f6;\n}\n\n.MachineViewSectionAmber {\n  background: #f3f4f6;\n}\n\n.MachineViewSectionPurple {\n  background: #f3f4f6;\n}\n\n.MachineViewSectionGray {\n  background: #f3f4f6;\n}\n\n.MachineViewSectionHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.MachineViewSectionTitle {\n  font-weight: 600;\n  color: #111827;\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin: 0;\n}\n\n.MachineViewSectionContent {\n  /* display: flex; */\n  /* flex-direction: column; */\n  gap: 8px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.MachineViewField {\n  display: flex;\n  flex-direction: column;\n}\n\n.MachineViewFieldLabel {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin: 0 0 2px 0;\n}\n\n.MachineViewFieldValue {\n  font-weight: 500;\n  color: #111827;\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin: 0;\n}\n\n.MachineViewDescription {\n  color: #374151;\n  font-family: \"Source Sans Pro\", sans-serif;\n  line-height: 1.6;\n  margin: 0;\n}\n@media (max-width: 425px) {\n  .MachineActionButton {\n    padding: 0px;\n    /* border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.15s ease; */\n  }\n  .MachineActionButtonView {\n    color: #2563eb;\n    background: none;\n  }\n  .MachineActionButtonEdit {\n    color: #d97706;\n    background: none;\n  }\n  .MachineActionButtonDelete {\n    color: #dc2626;\n    background: none;\n  }\n}\n/* Responsive Design */\n@media (min-width: 640px) {\n  .MachineActionBarContent {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n@media (min-width: 768px) {\n  .MachineFormGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .MachineViewGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .MachineHeaderContent {\n    /* flex-direction: row; */\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .MachineTitle {\n    font-size: 2.25rem;\n  }\n\n  .MachineMobileContainer {\n    display: none;\n  }\n\n  .MachineTableContainer {\n    display: block;\n  }\n}\n\n@media (max-width: 1023px) {\n  .MachineTableContainer {\n    display: none;\n  }\n\n  .MachineMobileContainer {\n    display: flex;\n  }\n}\n\n/* Full width for description field */\n.MachineFormFieldFull {\n  grid-column: 1 / -1;\n}\n.radio-group label {\n  font-size: 15px;\n  color: #374151;\n}\n\n.radio-group input[type=\"radio\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #3b82f6; /* or your primary color */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
